import { trigger, transition, style, animate } from '@angular/animations';

export const switchPanelAnimation = trigger('switchPanelAnimation', [
    transition(':enter', [style({ opacity: 0, position: 'absolute' }), animate('.1s ease', style({ opacity: 1 }))]),
    transition(':leave', [style({ opacity: 1, position: 'absolute' }), animate('.1s ease', style({ opacity: 0 }))])
]);
